import React from 'react';

import { EmptyIllustration } from '@dashboard/components/empty-states/EmptyIllustration';
import { createTableComponent } from '@dashboard/components/pages/QueryListPage/TableList/WpDataGrid';
import SimpleTextCell from '@dashboard/components/table/cells/SimpleTextCell';
import { FContactsGroupContactFragment } from '@dashboard/generated/wp/platform';
import usePlatformNavigator from '@dashboard/hooks/navigate/usePlatformNavigator';
import { Link, Tooltip, Typography } from '@mui/material';

import DeleteContactsGroupContactButton from './DeleteContactsGroupContactButton';
import useCurrentContactsGroupContacts from './useCurrentContactsGroupContacts';

const TableComponent = createTableComponent<FContactsGroupContactFragment>({
  emptyResults: (
    <EmptyIllustration
      caption={
        <Typography color="text.secondary">
          No contacts found. Learn how to use{' '}
          <Link target="_blank" href="https://www.usewaypoint.com/docs/unsubscribe-groups">
            unsubscribe groups
          </Link>
          .
        </Typography>
      }
    />
  ),
  columns: [
    {
      headerName: 'Name',
      renderCell: ({ row }) => <SimpleTextCell>{row.contactEmailAddress}</SimpleTextCell>,
    },
    {
      headerName: '',
      align: 'right',
      renderCell: ({ row }) => (
        <Tooltip title="Remove from group" placement="left">
          <span>
            <DeleteContactsGroupContactButton id={row.id} emailAddress={row.contactEmailAddress} />
          </span>
        </Tooltip>
      ),
    },
  ],
});

export default function TopicContactsTable() {
  const { data } = useCurrentContactsGroupContacts();
  const navigator = usePlatformNavigator();
  const nodes = data?.ContactsGroupContacts.nodes;
  return (
    <TableComponent
      nodes={nodes}
      onRowClick={(row) => {
        navigator.showContact(row.contactId, { modelIds: null });
      }}
    />
  );
}
